export function indexToOddOrEven(index: number) {
    if (index % 2 === 0) {
        return 'even';
    }
    return 'odd';
}
